export function TeamFlag({ iso_alpha2, name, size = "sm" }: { iso_alpha2: string; name?: string; size?: "xs" | "sm" | "md" }) {
  const sizeClass = size === "xs" ? "text-base" : size === "sm" ? "text-lg" : "text-xl";
  return (
    <span
      className={`fi fi-${iso_alpha2} ${sizeClass}`}
      role="img"
      aria-label={name}
    />
  );
}
